import { atom } from 'jotai';

export const checkoutFeaturesAtom = atom<string[] | undefined>();
